import clsx from 'clsx';

import { Pill } from '../pill';

type Variant = 'default' | 'cover';

const PageHeader = ({
  pill,
  title,
  caption,
  imgSrc,
  variant = 'default',
}: {
  pill?: string | React.ReactNode;
  title: string;
  caption?: string;
  imgSrc?: string;
  variant: Variant;
}) => {
  if (variant === 'cover') {
    return (
      <div
        className={clsx(
          'cur-relative cur-w-full cur-h-[240px] cur-min-h-[240px] cur-flex cur-flex-col cur-items-start cur-gap-[10px] cur-flex-shrink-0',
          'sm:cur-h-[307px] sm:cur-min-h-[307px]',
        )}
      >
        {pill && (
          <div className="cur-relative cur-z-10 cur-flex cur-flex-col cur-justify-between cur-items-start cur-flex-[1_0_0] cur-p-4 cur-self-stretch">
            <Pill variant="knockout">{pill}</Pill>
          </div>
        )}
        <div className="cur-relative cur-z-10 cur-flex cur-max-w-[250px] cur-flex-col cur-items-start cur-gap-[4px] cur-p-4 cur-self-stretch">
          <h1 className="cur-text-[32px] cur-font-bold cur-leading-[32px] cur-tracking-[-0.64px] cur-text-white">
            {title}
          </h1>
          {caption && (
            <p className="cur-text-[14px] cur-font-normal cur-leading-[133%] cur-text-white">
              {caption}
            </p>
          )}
        </div>
        {imgSrc && (
          <img
            src={imgSrc}
            alt=""
            className="cur-absolute cur-inset-0 cur-w-full cur-h-full cur-object-cover cur-object-center"
          />
        )}
        <div
          className="cur-absolute cur-w-full cur-h-full cur-inset-0 -cur-bottom-[60px]"
          style={{
            background:
              'linear-gradient(270deg, rgba(23, 46, 111, 0.00) 0%, rgba(23, 46, 111, 0.25) 100%)',
          }}
        />
      </div>
    );
  }

  if (variant === 'default') {
    return (
      <div
        className={clsx(
          'cur-relative cur-w-full cur-flex cur-flex-col cur-items-start cur-gap-[10px] cur-flex-shrink-0 cur-bg-core-purple-50',
          'sm:cur-rounded-t-[20px]',
        )}
      >
        {pill && (
          <div className="cur-relative cur-z-10 cur-flex cur-flex-col cur-justify-between cur-items-start cur-flex-[1_0_0] cur-p-4 cur-self-stretch">
            <Pill variant="default">{pill}</Pill>
          </div>
        )}
        <div className="cur-relative cur-z-10 cur-flex cur-flex-col cur-items-start cur-gap-[8px] cur-p-4 cur-self-stretch">
          <h1 className="cur-text-[32px] cur-font-bold cur-leading-[32px] cur-tracking-[-0.64px] cur-text-surface-secondary cur-whitespace-pre-wrap">
            {title}
          </h1>
          {caption && (
            <p
              className="cur-text-[14px] cur-font-normal cur-text-subtle cur-leading-[133%]"
              style={{ textWrap: 'balance' }}
            >
              {caption}
            </p>
          )}
        </div>
      </div>
    );
  }
};

export { PageHeader };
